export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-yelp-ecc8116c8516636b4c8c194d3c6ca8d9.svg";